import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { makeReownAppkit } from './reown/index.ts'
import { makeTronAppkit } from './tron/index.ts'
import App from './App.tsx'
import './style.css'
import { parseBrowser } from './bowser/index.ts'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)

declare global {
  interface Window {
    wallet_connect: {
      makeReownAppkit: typeof makeReownAppkit
      makeTronAppkit: typeof makeTronAppkit
    }
    parseBrowser: typeof parseBrowser
  }
}

// expose to window

window.wallet_connect = {
  makeReownAppkit,
  makeTronAppkit
}

window.parseBrowser = parseBrowser
